module.exports = __webpack_public_path__ + "img/icon-chevron-left.dea0f1e3.svg";